var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"display-2 text--primary"},[_vm._v(_vm._s(_vm.name))]),_c('p',{staticClass:"headline"},[_vm._v(_vm._s(_vm.summary))]),_c('p',{staticClass:"text--primary"},[_vm._v(_vm._s(_vm.description))])])}
var staticRenderFns = []

export { render, staticRenderFns }